import produce from 'immer';
import {
  PASSWORD_RESET_REQUEST,
  PASSWORD_RESET_REQUEST_SUCCESS,
  PASSWORD_RESET_REQUEST_ERROR,
  ENTER_PASSWORD,
  ENTER_PASSWORD_SUCCESS,
  ENTER_PASSWORD_ERROR,
  CHANGE_EMAIL
} from './constants';

export interface forgotPasswordState {
  loading: boolean;
  error: any;
  email: string;
  displayVerifyPhoneForm : boolean; 
}

export const initialState: forgotPasswordState = {
  loading: false,
  error: null,
  email: '',
  displayVerifyPhoneForm: false,
};

/* eslint-disable default-case, no-param-reassign */
const forgotPasswordReducer = (state = initialState, action: any) =>
  produce(state, draft => {
    switch (action.type) {
      case PASSWORD_RESET_REQUEST:
        draft.loading = true;
        draft.error = null;
        draft.displayVerifyPhoneForm = false;
        break;
      case PASSWORD_RESET_REQUEST_SUCCESS:
        draft.loading = false;
        draft.error = null;
        draft.displayVerifyPhoneForm = action.data.phone ? true: false;
        break;
      case PASSWORD_RESET_REQUEST_ERROR:
        draft.loading = false;
        // draft.error = action.error.response ? action.error.response.status : 0;
        break;
      case ENTER_PASSWORD:
        draft.loading = true;
        draft.error = null;
        break;
      case ENTER_PASSWORD_SUCCESS:
        draft.loading = false;
        draft.error = null;
        break;
      case ENTER_PASSWORD_ERROR:
        draft.loading = false;
        draft.error = action.error.response ? action.error.response.status : 0;
        break;        
      case CHANGE_EMAIL:       
        draft.email = action.email;
        break;        
    }
  });

export default forgotPasswordReducer;
